module.exports = "<p>\n  create-user-page works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/onboarding/components/create-user-page/create-user-page.component.html
// module id = ./src/app/onboarding/components/create-user-page/create-user-page.component.html
// module chunks = main